module.exports = __webpack_public_path__ + "static/media/order-placed.1dacd934.gif";